import React, { useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import CardWithTitle from 'components/CardWithTitle';
import FSBModal from 'components/common/FSBModal';
import DebounceTextInput from 'components/DebounseTextInput';
import StaffAllocateVendorList from '../StaffAllocateVendorList';
import AssignAnotherRM from '../StaffAllocateVendorList/components/AssignAnotherRM';
import AddAllocateVendor from '../StaffAllocateVendorList/components/AddAllocateVendor';

const StaffVendorDetails = ({ drawerToggle, staffId, roleList }) => {
  const [searchString, setSearchString] = useState('');
  const [rowSelection, setRowSelection] = useState({});
  const [updateRecordModal, setUpdateRecordModal] = useState(false);
  const [addRecordModal, setAddRecordModal] = useState(false);
  const [vendorList, setVendorList] = useState([]);

  const handleChange = (value) => {
    setSearchString(value);
  };

  const onSelectedRowsChange = async (rows) => {
    await setRowSelection(rows);
  };

  const handleRMToggle = () => {
    setUpdateRecordModal(!updateRecordModal);
  };
  const onCloseUpdatePopup = () => {
    setUpdateRecordModal(!updateRecordModal);
  };

  const onCloseAddPopup = () => {
    setAddRecordModal(!addRecordModal);
  };

  return (
    <div>
      {' '}
      <CardWithTitle title="Allocated Vendor">
        <Row>
          <Col sm={6}>
            <Button
              size="sm"
              color="primary"
              className="me-3"
              onClick={() => setAddRecordModal(!addRecordModal)}
            >
              Add Vendors
            </Button>
            <Button
              size="sm"
              color="primary"
              onClick={handleRMToggle}
              disabled={Object.keys(rowSelection).length === 0}
            >
              Assign another {roleList?.length > 0 ? 'BDE' : 'RM'}
            </Button>
          </Col>
          <Col className="text-end" sm={6}>
            <DebounceTextInput
              onInputChange={handleChange}
              delay={500} // Set your desired delay in milliseconds
              value={searchString}
              placeholder="Search by name or phone no."
            />
          </Col>
        </Row>
        <FSBModal
          title={`Allocate ${roleList?.length > 0 ? 'BDE' : 'RM'}`}
          closeButtonLabel=""
          confirmButtonLabel=""
          message=""
          open={updateRecordModal}
          onClose={onCloseUpdatePopup}
          toggleAlert={onCloseUpdatePopup}
          modalClass="right-drawer right-drawer-details assign-vendor"
        >
          <AssignAnotherRM
            id={staffId}
            onCloseUpdatePopup={onCloseUpdatePopup}
            rowSelection={Object.keys(rowSelection)}
            drawerToggle={drawerToggle}
            roleList={roleList}
          />
        </FSBModal>

        <FSBModal
          title={`Assign Vendors to ${roleList?.length > 0 ? 'BDE' : 'RM'}`}
          closeButtonLabel=""
          confirmButtonLabel=""
          message=""
          open={addRecordModal}
          onClose={onCloseAddPopup}
          toggleAlert={onCloseAddPopup}
          modalClass="right-drawer right-drawer-details assign-vendor"
        >
          <AddAllocateVendor
            id={staffId}
            onCloseAddPopup={onCloseAddPopup}
            drawerToggle={drawerToggle}
            roleList={roleList}
            vendorList={vendorList}
          />
        </FSBModal>
        <StaffAllocateVendorList
          setVendorList={setVendorList}
          searchString={searchString}
          staffId={staffId}
          drawerToggle={drawerToggle}
          rowSelection={rowSelection}
          onSelectedRowsChange={onSelectedRowsChange}
          roleList={roleList}
        />
      </CardWithTitle>
    </div>
  );
};

export default StaffVendorDetails;
